/*
###################################################################
Fitinsur Open Insurance - Copyright 2019-2023 - All Rights Reserved
###################################################################
*/

import styled from "styled-components";
import { Breakpoints } from "../../../constants/Breakpoints";
import Colors from "../../../constants/Colors";
import { FiraSansBold, FontWeight } from '../../Text';


const Container = styled.div`
  width: 100%;
  height: 100%;
  min-height: 1040px;

  @media (min-width: ${Breakpoints.md}) {
    height: 100%;
    min-height: 100%;
  }
`;

const ButtonContainer = styled.div`
  display: inline-flex;
  width: 100%;
  height: 10%;
  margin-top: 2%;
`;

const Button = styled.button`

  font-size: 16px;
  font-weight: ${FontWeight.Regular};
  color: ${Colors.GRAY[6]};

  padding: 0.10rem 0.20rem;
  width: auto;
  text-transform: uppercase;
  letter-spacing: -0.5px;
  height: 42px;
  white-space: nowrap;
  margin: 0px 0px 0px 0px;

  ${FiraSansBold}

  border: 0 none;
  border-radius: 8px;
  background: transparent;

  cursor: pointer;
  transition: background-color 0.15s ease, color 0.15s ease, width 0.3s ease, border 0.5s ease, border-color 0.5s ease, box-shadow 0.15s ease;

  text-align: center;
  &:focus,
  &:active { outline: none; }

  &:disabled {
    opacity: 0.4;
    cursor: not-allowed;
  }

  @media(min-width: ${Breakpoints.sm}) {  
    padding: .75rem .75rem;
    width: auto;
  }
  @media (min-width: ${Breakpoints.xl}) and (max-width: ${Breakpoints.xxl}) {  
    padding-right: 600px;
    width: 100%;
    font-size: 13px;
    text-align: center;
  }

  @media (min-width: ${Breakpoints.xxs}) and (max-width: ${Breakpoints.lg}) {  
    padding-right: 250px;
    width: 100%;
    font-size: 12px;
    text-align: center;
    
  }
`;


const Content = styled.div`
  width: 100%;
  margin: 0% 0% 5% 5%;

  @media screen (max-width: ${Breakpoints.md}) {
    max-height: 100%;
    height: 100%;
  }
`;

const Scrollbox = styled.div`
  overflow-y: auto;
  overflow-x: hidden;
  padding: 2px 10px;
  width: 100%;
  height: 100%;
  margin-top: 10px;

  ::-webkit-scrollbar {
    background: ${Colors.WHITE};
    width: 8px;
  }
  ::-webkit-scrollbar-thumb {
    background: ${Colors.GRAY[3]};
    border-radius: 15px;
  }

  @media (max-width: ${Breakpoints.sm}) {
    max-height: 100%;
    height: 100%;
  }
`;

export const BorderSwitch = styled.div`  
  background: ${Colors.GRAY[6]};
  padding-left: 1px;
  border-radius: 14px;
  width: 57px;
  padding-top: 1px;
  padding-right: 1px;
  height: 30px;
  display: -webkit-inline-box;
  margin-left: 5px;
`;

const Table = styled.table`
  width: 100%; 
  min-height: 200px;
  display: table
  padding-right: 15px;
  padding-bottom: 20px;
`;

const Thead = styled.th`
  text-align: center;
  text-decoration: underline;
  font-size: 16px;
  font-weight: ${FontWeight.Regular};
  color: ${Colors.GRAY[6]};

  &.title {
    font-weight: ${FontWeight.Bold};
    text-align: left;
    text-decoration: none;
  }
  &.not-title {
  }

  @media (min-width: ${Breakpoints.xxs}) and (max-width: ${Breakpoints.lg}) {  
    font-size: 12px;    
  }
`;

const TableRow = styled.tr`
  display: table-row;
  width: 100%;
  height: 4.5vh;
`;

const TableHead = styled.thead`
  display: table-header-group;
  width: 100%;
`;

const Tbody = styled.tbody`
  width: 100%;
  display: table-row-group;
`;

const Td = styled.td`
  text-align: left;
  padding-left: 15px;
  width: 75%;
  font-size: 15px;
  font-weight: ${FontWeight.Regular};
  color: ${Colors.GRAY[6]};

  @media (min-width: ${Breakpoints.xxs}) and (max-width: ${Breakpoints.lg}) {  
    font-size: 12px;
  }

`;

export {
  Container,
  ButtonContainer,
  Content,
  Scrollbox,
  Table,
  TableRow,
  TableHead,
  Thead,
  Tbody,
  Td,
  Button,
};
